import React, { useId } from 'react';

import styles from './ripple.module.css';

import { AILogoPaths } from '@/components/logo/ai-logo';
import { cn } from '@/lib/utils';

export interface RippleProps extends React.SVGAttributes<SVGSVGElement> {
  colored?: boolean;
}

export function Ripple({ className, colored = false, ...props }: RippleProps) {
  const gradientId = `ai-logo-gradient-${useId()}`;

  return (
    <svg
      className={cn(styles.loader, !colored && styles.monochrome, className)}
      width={48}
      height={48}
      viewBox="0 0 72 72"
      role="img"
      aria-label="Loading"
      {...props}
    >
      <AILogoPaths variant={colored ? 'yellowfin' : 'monochrome'} gradientId={gradientId} />
    </svg>
  );
}
